import { Dispatch } from 'redux'

import * as SourceApi from 'redux/api/DataPlatform/connections/sources/v1'
import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

export function tryGetAllSources() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    SourceApi.getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryGetOneSource(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getOne())

    SourceApi.getOne(id)
      .then((response) => {
        dispatch(
          actions.getOneSuccess({ ...response.data, activeSourceId: id })
        )
      })
      .catch(() => {
        dispatch(actions.getOneFailed())
      })
  }
}

export const useSourcesActions = () => {
  return {
    tryGetAllSources: useThunkActions(tryGetAllSources),
    tryGetOneSource: useThunkActions(tryGetOneSource)
  }
}
